import React from 'react';
import { Button } from '@/components/shadcn/button';
import { initCapitalize } from '@/utils/strings';
import { cn } from '@/utils/styles';

interface Props {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  styling?: {
    width: string;
    backgroundColor: string;
    backgroundColorHover: string;
  };
  type?: 'button' | 'submit';
  sublabel?: string;
}

export default function TrainerButton({
  label,
  onClick,
  disabled,
  styling,
  type = 'button',
  sublabel = '',
}: Props) {
  const className =
    'min-w-auto m-1 flex h-12 min-h-12 cursor-pointer items-center justify-center rounded-md p-1 px-2 text-center text-md font-bold leading-normal text-neutral-900 transition-all duration-300 ease-in-out disabled:text-neutral-900 disabled:opacity-50 bg-neutral-100 hover:bg-azure-500 hover:text-neutral-900';
  const styleOverrides = {
    backgroundColor: styling?.backgroundColor ?? 'neutral.0',
    backgroundColorHover: styling?.backgroundColorHover ?? 'azure.500',
    minWidth: styling?.width ?? '50px',
  };

  const imageUrlPattern = /\.(jpeg|jpg|gif|png|bmp|svg)$/i;
  const isImageButton = imageUrlPattern.test(label);
  let imageName: string | undefined;
  let imageButtonSyles = '';
  const formattedLabel = initCapitalize(label.replace(/USE_LABEL/g, sublabel));
  if (isImageButton) {
    imageName = label.split('/').pop()?.split('#')[0].split('?')[0];
    imageButtonSyles =
      'bg-transparent p-0 h-auto w-auto rounded-none cursor-pointer hover:bg-transparent';
  }

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className={cn([className, imageButtonSyles])}
      style={styleOverrides}
      type={type}>
      {isImageButton ? (
        <img
          src={label}
          alt={imageName ?? 'Trainer button image'}
          className={'max-w-full'}
        />
      ) : (
        formattedLabel
      )}
    </Button>
  );
}
